module.exports = __webpack_public_path__ + "img/placeholder.5a1da741.jpeg";